import React, { useState, useEffect } from 'react';

export const NoAi = () => {
    const [isVisible, setIsVisible] = useState(true);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 100) {
                setIsVisible(false);
            } else {
                setIsVisible(true);
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <div className={`no-ai-container ${isVisible ? '' : 'hidden'}`}>
            <div className="no-ai-box">
                <div className="no-ai-title">
                    <span>We do not use </span>
                    <span className="ai-text">AI!</span>
                    <div className="no-ai-logo">
                        <span>AI</span>
                    </div>
                </div>
                <p className="no-ai-description">
                    We want to preserve games as works of art, not as the product of artificial intelligence.
                </p>
            </div>
        </div>
    );
};